/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Detail_Field_Deactivated_ByInputs */



/**
* | output |
* | --- |
* | "Deactivated by" |
*
* @param {Member_Detail_Field_Deactivated_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_detail_field_deactivated_by = /** @type {((inputs?: Member_Detail_Field_Deactivated_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Detail_Field_Deactivated_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deaktiviert von")
	return /** @type {LocalizedString} */ ("Deactivated by")
});